import { put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { axiosInstance } from "../../config/axios";
import { apiEndpoints } from "../../utils/api-endpoints";
import { createErrorAction } from '../reducers/errorSlice';
import {
    getAllUsersSuccess,
    createUserSuccess,
    updateUserSuccess,
    deleteUserSuccess,
} from "../reducers/userSlice";
import { User } from "../../models/user.model";
import { getAllUsersFailed, createUserFailed, updateUserFailed, deleteUserFailed } from "../reducers/userSlice";
import { getErrorMessage } from "../../utils/helper.utils";

interface UpdateUserPayload {
    id: string;
    userData: Partial<User>;
}

function* getAllUsers(): Generator {
    try {
        const response = yield axiosInstance.get(apiEndpoints.user.getAll);
        yield put(getAllUsersSuccess(response.data));
    } catch (error: any) {
        yield put(getAllUsersFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'user/getAllUsers'));
    }
}

function* createUser(action: PayloadAction<User>): Generator {
    try {
        const response = yield axiosInstance.post(apiEndpoints.user.create, action.payload);
        yield put(createUserSuccess(response.data));
    } catch (error: any) {
        yield put(createUserFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'user/createUser'));
    }
}

function* updateUser(action: PayloadAction<UpdateUserPayload>): Generator {
    try {
        const { id, userData } = action.payload;
        const response = yield axiosInstance.put(apiEndpoints.user.update(id), userData);
        yield put(updateUserSuccess(response.data));
    } catch (error: any) {
        yield put(updateUserFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'user/updateUser'));
    }
}

function* deleteUser(action: PayloadAction<string>): Generator {
    try {
        yield axiosInstance.delete(apiEndpoints.user.delete(action.payload));
        yield put(deleteUserSuccess(action.payload));
    } catch (error: any) {
        yield put(deleteUserFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'user/deleteUser'));
    }
}

export function* watchUserSaga() {
    yield takeLatest("user/getAllUsers", getAllUsers);
    yield takeLatest("user/createUser", createUser);
    yield takeLatest("user/updateUser", updateUser);
    yield takeLatest("user/deleteUser", deleteUser);
}
